import { useRef } from 'react';
import { useForm } from 'react-hook-form';
import { IntlShape, useIntl } from 'react-intl';
import jwt_decode from 'jwt-decode';
import cn from 'classnames';

import { logOut, MARKETPLACE_DEV_CONTEXT, MARKETPLACE_GWT } from '@marketplace/common';
import { useAPIRegisterExternalDeveloper } from '@marketplace/api';
import { Checkbox, Dialog } from '@marketplace/ui-elements';
import { TERMS_OF_SERVICE, DEV_BEST_PRACTICES,DEV_README_PREFIX} from '@developer/constants';

import { redirectTo } from '../helpers';
import classes from './auth-agreemen-dialog.module.scss';
import { TParsedToken } from '../auth.types';

export const AuthAgreementDialog = (): JSX.Element => {
  const apiRegisterExternalDeveloper = useAPIRegisterExternalDeveloper();
  const { formatMessage }: IntlShape = useIntl();
  const formRef = useRef<HTMLFormElement>(null);
  const { handleSubmit, formState, control, watch } = useForm({ mode: 'onChange' });
  const fieldAgreeValue = watch('agree');
  const isAccept = fieldAgreeValue && watch('agree') === true;

  const handleRejectForm = () => {
    logOut(true,DEV_README_PREFIX);
    window.location.reload();
  };

  const handleSubmitForm = async () => {
    const developerContextData = await apiRegisterExternalDeveloper.registerExternalDeveloper();

    if (developerContextData?.data) {
      localStorage.setItem(MARKETPLACE_DEV_CONTEXT, JSON.stringify(developerContextData?.data));
    }

    const token = localStorage.getItem(MARKETPLACE_GWT);
    const parsedToken: TParsedToken = jwt_decode(token || '');

    redirectTo(parsedToken);
  };

  const triggerSubmitForm = (): void => {
    formRef.current?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  };

  return (
    <Dialog
      visible
      rootClassName={classes.authDialog}
      header={formatMessage({ id: 'developer_landing_auth_dialog_title' })}
      rejectLabel={formatMessage({ id: 'developer_landing_auth_dialog_btn_cancel' })}
      acceptLabel={formatMessage({ id: 'developer_landing_auth_dialog_btn_submit' })}
      isLoading={apiRegisterExternalDeveloper.loading}
      isAcceptDisable={!isAccept}
      onReject={handleRejectForm}
      onAccept={triggerSubmitForm}
    >
      <form onSubmit={handleSubmit(handleSubmitForm)} ref={formRef} id="auth-agreement-form">
        <div className={cn(classes.agree)}>
          {formatMessage(
            { id: 'registrationLocation_term1' },
            {
              terms: (
                <a href={TERMS_OF_SERVICE} target="_blank" rel="noreferrer">
                  {formatMessage({ id: 'registrationLocation_term2' })}
                </a>
              ),
              code: (
                <a href={DEV_BEST_PRACTICES} target="_blank" rel="noreferrer">
                  {formatMessage({ id: 'registrationLocation_term3' })}
                </a>
              ),
            }
          )}
        </div>
        <div className={classes.row}>
          <Checkbox
            control={control}
            error={formState.errors.agree?.message}
            rootClassName={classes.agreeCheckbox}
            label={formatMessage({ id: 'registrationLocation_agreeV2' })}
            fieldId="agree"
            name="agree"
          />
        </div>
      </form>
    </Dialog>
  );
};
